import Pagination from "./Pagination/index";
import EdgeLockScroll from "./EdgeLockScroll";
import EntityCount from "./EntityCount/index";
import IconComposer from "./IconComposer";
import LockBodyScroll from "./LockBodyScroll";
import ScrollToTop from "./ScrollToTop";
import SetCSSProperty from "./SetCSSProperty";
import SkipLink from "./SkipLink";
import LabelWithIcon from "./LabelWithIcon";
import RouteAnnouncer from "./RouteAnnouncer";

export default {
  Pagination,
  EdgeLockScroll,
  EntityCount,
  IconComposer,
  LockBodyScroll,
  ScrollToTop,
  SkipLink,
  LabelWithIcon,
  SetCSSProperty,
  RouteAnnouncer
};
